import * as React from "react";

import "./basemap-gallery-button.scss";
import {Button, Image, Transition} from "semantic-ui-react";
import {Icon} from "../../icon/icon";

export interface BasemapGalleryButtonProps {
    isExpanded: boolean;  // widgetsSearch is also the type for configuration object
    isLoading: boolean;
    isOrthophoto: boolean | null;
    mapToggle: string[];
    duration: number;
    onClick: any;
}

export class BasemapGalleryButton extends React.Component<BasemapGalleryButtonProps, any> {

    constructor(props: BasemapGalleryButtonProps) {
        super(props);
    }

    render(): JSX.Element {
        if(this.props.isLoading){
            return (
                <Button
                    className="geo-component geo-widget geo-popup--shadow geo-basemap-gallery-expand"
                    loading={this.props.isLoading}
                    icon="map"
                />
            );
        }
        let btnImage;
        let btnClass = "geo-component geo-widget geo-popup--shadow geo-basemap-gallery-expand";
        if (this.props.isOrthophoto !== null) {
            btnImage = (
                <Image src={this.props.isOrthophoto ? this.props.mapToggle[1] : this.props.mapToggle[0]}/>
            );
            if (this.props.isOrthophoto) {
                btnClass += " geo-button-orthophoto";
            }
        } else {
            btnImage = (
                <Icon name="map" />
            );
        }
        return (
            <Transition visible={!this.props.isExpanded} animation="scale" duration={this.props.duration}>
                <Button
                    className={btnClass}
                    loading={this.props.isLoading}
                    onClick={this.props.onClick}>
                    <div>{btnImage}</div>
                </Button>
            </Transition>
        );
    }
}
